import ListLanguageFolder from './list-language-folder';

export default ListLanguageFolder;
